import { layoutOf } from "../utils/selfcheckoutMode";

// Ver LAYOUT_BY_MODE em utils/selfcheckoutMode.js.
export const selectLayout = (state) => layoutOf(state.shop);
